import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Dialog, FormControl, FormControlLabel, FormGroup, Stack, Paper, FormHelperText, DialogActions, CircularProgress } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid } from "@mui/material";
import Select from "react-select";
import { CustomizedSnackbar } from './index';
import { useDispatch, useSelector } from "react-redux";
import { SnackbarActions } from '../redux/actions/snackbar.actions'
import { manager_update, profile_details } from '../redux/actions/user.actions'
import { training_list, training_details } from '../redux/actions/training.action';
import { loadJobTitle, loadReportingManagers, loadTrainingLevel, loadTrainingType, loadEmployeeLevel } from '../redux/actions/lookups.action'
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useNavigate } from "react-router";
import { axiosFetch } from "../utils/AxiosFetch";
import MaskedInput from 'react-maskedinput'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  maxWidth: 50,
  maxHeight: 30
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


function CommonModal(props) {
  const [open, setOpen] = useState(props.openModal);
  const [module, setModule] = useState(props.module);
  const [trainingLevelOption, setTrainingLevelOption] = useState([]);
  const [trainingTypeOption, setTrainingTypeOption] = useState([]);
  const [employeeLevelOption, setEmployeeLevelOption] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [trainer, setTrainer] = useState("");
  const [skillset, setSkillset] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [level, setLevel] = useState("");
  const [empLevel, setEmpLevel] = useState("");
  const [type, setType] = useState("");
  const [timeduration, setTimeDuration] = useState("");
  const [maxSlot,setMaxSlot] = useState("");
  const [hours, setHours] = useState("");
  const [mins, setMins] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [employeError, setEmployeError] = useState(false);
  const [levelError, setLevelError] = useState(false);
  const [typeError, setTypeError] = useState(false);
  const [timeError, setTimeError] = useState(false);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let LUReportingManager = useSelector(state => state.loadReportingManagers_Reducer.managerList);
  let LUTrainingLevel = useSelector(state => state.loadTrainingLevel_Reducer.trainingLevelList);
  let LUTrainingType = useSelector(state => state.loadTrainingType_Reducer.trainingTypeList);
  let TrainingDetail = useSelector(state => state.fetchTrainingDetails_Reducer.trainingDetails);
  let LUEmployeeLevel = useSelector(state => state.loadEmployeeLevel_Reducer.employeeLevel);


  useEffect(() => {
    if (LUTrainingLevel.length > 0) {
      setTrainingLevelOption(LUTrainingLevel)
    }
  }, [LUTrainingLevel])

  useEffect(() => {
    if (LUTrainingType.length > 0) {
      setTrainingTypeOption(LUTrainingType)
    }
  }, [LUTrainingType])

  useEffect(() => {
    if (LUEmployeeLevel.length > 0) {
      setEmployeeLevelOption(LUEmployeeLevel)
    }
  }, [LUEmployeeLevel])


  const handleClose = () => {
    props.handlepopupState();
    setOpen(false);
  };

  useEffect(() => {
    console.log(props)
    setOpen(props.openModal)
    if (props.openModal) {     
      if (props.module === "addnewTraining") {
        dispatch(loadTrainingLevel());
        dispatch(loadTrainingType());
        dispatch(loadEmployeeLevel());
        if (props.editId !== 0 && props.isTrainingEdit !== false) {
          dispatch(training_details(props.editId))
        }
      }
    }
    if (props.openModal === false) {
      setTitle("");
      setDescription("");
      setUrl("");
      setTrainer("");
      setSkillset("");
      setStartDate("");
      setEndDate("");
      setLevel("");
      setEmpLevel("");
      setType("");
      setTimeDuration("");
      setMaxSlot("")
      setHours("");
      setMins("");
      setTimeError(false)
    }
  }, [props])
  useEffect(() => {
    if (props.isTrainingEdit === false) {
      setTitle("");
      setDescription("");
      setUrl("");
      setTrainer("");
      setSkillset("");
      setStartDate("");
      setEndDate("");
      setLevel("");
      setEmpLevel("");
      setType("");
      setTimeDuration("");
      setMaxSlot("")
      setHours("");
      setMins("");
    }
  }, [props.isTrainingEdit])

  useEffect(() => {
    if (props.editId !== 0 || props.isTrainingEdit !== false) {
      dispatch(training_details(props.editId))
    }
  }, [props.editId])

  useEffect(() => {
    if ((props.isTrainingEdit === true && TrainingDetail !== undefined && TrainingDetail.length !== 0) || props.TrainingStatus === "Completed") {
      setTitle(TrainingDetail.title)
      setDescription(TrainingDetail.description);
      setUrl(TrainingDetail.referenceUrl);
      setTrainer(TrainingDetail.trainerName);
      setSkillset(TrainingDetail.skillSet);
      setMaxSlot(TrainingDetail.maxSlot);
      if (props.TrainingStatus === "Completed") {
        setStartDate("");
        setEndDate("")
      }
      else {
          setStartDate(new Date(TrainingDetail.startDate))
          setEndDate(new Date(TrainingDetail.endDate))
      }
      setTimeDuration(TrainingDetail.durationHours)
      if (TrainingDetail.trainingLevelId !== null && TrainingDetail.trainingLevelId !== "") {
        if (LUTrainingLevel.length > 0) {
          LUTrainingLevel.filter((option) => {
            if (TrainingDetail.trainingLevelId === parseInt(option.value)) {
              var value = []
              value.push(option)
              setLevel(value)
            }
          })
        }
      }
      if (TrainingDetail.employeeLevelId !== null && TrainingDetail.employeeLevelId !== "") {
        if (LUEmployeeLevel.length > 0) {
          LUEmployeeLevel.filter((option) => {
            if (TrainingDetail.employeeLevelId === parseInt(option.value)) {
              var value = []
              value.push(option)
              setEmpLevel(value)
            }
          })
        }
      }
      if (TrainingDetail.durationHours !== "" && TrainingDetail.durationHours !== null) {

        if (TrainingDetail.durationHours.includes(":")) {
          var h = TrainingDetail.durationHours.split(":")[0];
          var m = TrainingDetail.durationHours.split(":")[1];
          setHours(h);
          setMins(m);
        }
        else {
          setHours(TrainingDetail.durationHours)
        }
      }
      if (TrainingDetail.trainingType !== null && TrainingDetail.trainingType !== "") {
        if (LUTrainingType.length > 0) {
          LUTrainingType.filter((option) => {
            if (TrainingDetail.trainingType === parseInt(option.value)) {
              var value = []
              value.push(option)
              setType(value)
            }
          })
        }
      }
    }
  }, [TrainingDetail])

  const handleCreate = () => {
    if (startDate && endDate && type && level && empLevel && timeduration && timeduration !== "00:00" && timeduration !== null) {
      var reqUrl = "/Training/new";
      var levelId = level[0].value;
      var empLeveleId = empLevel[0].value;
      var trainingtype = type[0].value;
      var time = timeduration.replace("__", "00");
      var timedur = time.replace("_", 0);
      var req = {
        "title": title,
        "description": description,
        "startDate": moment(startDate).format('YYYY-MM-DD'),
        "endDate": moment(endDate).format('YYYY-MM-DD'),
        "referenceUrl": url,
        "skillSet": skillset,
        "employeeLevelId": parseInt(empLeveleId),
        "trainingLevelId": parseInt(levelId),
        "trainingType": parseInt(trainingtype),
        "trainerName": trainer,
        "durationHours": timedur,
        "maxSlot":parseInt(maxSlot)
      }
      if (props.isTrainingEdit === true && props.editId !== 0) {
        reqUrl = "/Training/update";
        req = {
          "id": props.editId,
          "title": title,
          "description": description,
          "startDate": moment(startDate).format('YYYY-MM-DD'),
          "endDate": moment(endDate).format('YYYY-MM-DD'),
          "referenceUrl": url,
          "skillSet": skillset,
          "trainingLevelId": parseInt(levelId),
          "trainingType": parseInt(trainingtype),
          "employeeLevelId": parseInt(empLeveleId),
          "trainerName": trainer,
          "durationHours": timedur,
          "maxSlot":parseInt(maxSlot)
        }
      }
      axiosFetch({
        url: reqUrl,
        method: "post",
        requestConfig: req
      })
        .then((res) => {
          if (res.status === 200) {
            dispatch(SnackbarActions(true, "success", props.isTrainingEdit === true ? "Training Updated Successfully" : "New training created succesfully"))
            handleClose();
            dispatch(training_list())
          }
          if (res.status === 400) {

            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          }
          if (res.status === 401) {
            navigate("/");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    else {
      if (startDate === "") {
        setStartDateError(true)
      }
      if (endDate === "") {
        setEndDateError(true)
      }
      if (type.length < 1) {
        setTypeError(true)
      }
      if (level.length < 1) {
        setLevelError(true)
      }
      if (timeduration === "" || timeduration === "00:00" || timeduration === null) {
        setTimeError(true)
      }
      if (empLevel.length < 1) {
        setEmployeError(true)
      }
    }

  }

  const handleStartDate = (date) => {
    setStartDate(date)
    setEndDate("")
    setStartDateError(false)
  }
  const handleEndDate = (date) => {
    setEndDate(date)
    setEndDateError(false)
  }
  const handleTypeChange = (selected) => {
    var name = [];
    name.push(selected);
    setType(name)
    setTypeError(false)
  }
  const handleLevelChange = (selected) => {
    var name = [];
    name.push(selected);
    setLevel(name)
    setLevelError(false)
  }
  const handleEmpLevelChange = (selected) => {
    var name = [];
    name.push(selected);
    setEmpLevel(name);
    setEmployeError(false)
  }
  ValidatorForm.addValidationRule('offlineNeedName', (value) => {
    if (type.length > 0) {
      if (type[0].value === "2" && value === "") {
        return false;
      }
      return true;
    }
    return true;
  });
  ValidatorForm.addValidationRule('isValidURL', (value) => {
    var pattern = /^(ftp|http|https):\/\/[^ "]+$/
    if (value !== "" && !(pattern.test(value))) {
      return false;
    }
    return true
  });
  ValidatorForm.addValidationRule('slotValidation', (value) => {
    if (parseInt(value) < 0) {
        return false;      
    }
    return true;
  });

  const handleDuration = (e) => {
    setTimeDuration(e.target.value);
    setTimeError(false)
  }
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth="md"
        maxWidth="md"
      >        
        {module === "addnewTraining" ?
          <><BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            className="modal-heading"
          >
            Add Training
          </BootstrapDialogTitle>
            <ValidatorForm style={{ backgroundColor: "#fff" }} onSubmit={() => handleCreate()}>
              <DialogContent dividers
                style={{ backgroundColor: "#fff" }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      fullWidth
                      label="Training Title"
                      type="text"
                      validators={["required"]}
                      errorMessages={["Please fill out this field"]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl sx={{ width: "100%" }}>
                      <FormControlLabel
                        control={<DatePicker
                          minDate={moment().toDate()}
                          placeholderText="Start Date"
                          fullWidth
                          className="datetime"
                          dateFormat="MMM-dd-yyyy"
                          selected={startDate}
                          onSelect={(date) => handleStartDate(date)}
                          disabled={props.TrainingStatus === "OnGoing" ? true : false}
                        />}
                      />
                      {startDateError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl sx={{ width: "100%" }}>
                      <FormControlLabel
                        control={<DatePicker
                          minDate={startDate}
                          placeholderText="End Date"
                          selected={endDate}
                          className="datetime "
                          fullWidth
                          onSelect={(date) => handleEndDate(date)}
                          dateFormat="MMM-dd-yyyy"
                        />}
                      />
                      {endDateError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      fullWidth
                      label="Training Description"
                      type="text"
                      rows={3}
                      multiline
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Ref. URL</h3>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      fullWidth
                      label="Reference URL"
                      type="url"
                      validators={["isValidURL"]}
                      errorMessages={["Enter valid url"]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Trainer Name</h3>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={trainer}
                      onChange={(e) => setTrainer(e.target.value)}
                      fullWidth
                      label="Trainer Name"
                      type="text"
                      validators={["offlineNeedName"]}
                      errorMessages={["Please fill out this field"]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Total Training Duration</h3>
                    <Stack direction="row" spacing={1}>
                      <Item>
                        <MaskedInput style={{ height: "50px", borderRadius: "5px", border: "1px solid grey", padding: "5px", textAlign: "center" }} mask="11:11" name="duration" placeholder="HH:MM" value={timeduration} onChange={(e) => handleDuration(e)} />
                      </Item>
                    </Stack>
                    <br />
                    {timeError ? <p className="error-message">Please fill out this field</p> : ""}
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Maximum No.of slots<span style={{fontSize:"3px"}}>(Give 0 for no-limit)</span></h3>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={maxSlot}
                      fullWidth
                      label="Maximum No.of slots"
                      type="number"
                      validators={["slotValidation"]}
                      errorMessages={["No.of slots should be one and above"]}
                      onChange={(e) => setMaxSlot(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Skillset</h3>
                    <TextValidator
                      id="input-with-icon-textfield"
                      variant="outlined"
                      value={skillset}
                      fullWidth
                      label="Skillsets"
                      type="text"
                      onChange={(e) => setSkillset(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Experience/Level</h3>
                    <FormControl sx={{ width: "100%" }}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Select
                              className="training-select"
                              value={empLevel}
                              options={employeeLevelOption}
                              onChange={handleEmpLevelChange}
                              menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                          }
                        />
                      </FormGroup>
                      {employeError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Training Level</h3>
                    <FormControl sx={{ width: "100%" }}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Select
                              className="training-select"
                              value={level}
                              options={trainingLevelOption}
                              onChange={handleLevelChange}
                              menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                          }
                        />
                      </FormGroup>
                      {levelError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <h3 className="input-head">Training Type</h3>
                    <FormControl sx={{ width: "100%" }}>
                      <FormGroup>
                        <FormControlLabel className="type"
                          control={<Select
                            className="training-select"
                            value={type}
                            options={trainingTypeOption}
                            onChange={handleTypeChange}
                            menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />}
                        />
                      </FormGroup>
                      {typeError ? <FormHelperText className="error-message">Please fill out this field</FormHelperText> : ""}
                    </FormControl>
                  </Grid>
                </Grid>
                {/* </Box> */}
              </DialogContent>
              <DialogActions>
                <Button className="theme-btn cancel-btn" variant="contained" onClick={() => handleClose()}>Cancel</Button>
                {loading?
                <CircularProgress size="2rem"/>:
                <Button className="theme-btn" variant="contained" type="submit">Submit</Button>}
              </DialogActions>
            </ValidatorForm>

          </>
          : ""}
      </BootstrapDialog>

      <CustomizedSnackbar />
    </div>
  );
}
export default CommonModal;
